import { createReducer } from "redux-act";

import * as actions from "../../actions";

const initial_state = {
	selected: null
};

export const uiSelectedLeague = createReducer({}, initial_state);

uiSelectedLeague.on(actions.uiSelectedLeague.setSelectedLeague, (state, payload) => ({
	...state,
	selected: payload
}));

uiSelectedLeague.on(actions.uiSelectedLeague.clearSelectedLeague, state => ({
	...state,
	selected: null
}));


// WEBPACK FOOTER //
// ./src/modules/reducers/uiSelectedLeague/index.js